import { useCallback, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import pick from 'lodash/pick'
import { getSummaryFromFiles } from 'utils/filter'
import { arrayDifference } from 'utils/helpers'
import { favoriteSelector, markFavorite } from 'features/favorite/favoriteSlice'

export const useFileFavorites = (data = [], selectedFiles) => {
    const dispatch = useDispatch()
    const { summary, latestDateTime } = useSelector(state => state.favorites)
    const favoriteFileIds = useSelector(state => favoriteSelector.selectIds(state))
    const favoriteFiles = useSelector(state => favoriteSelector.selectAll(state))

    const files = data.length ? data : favoriteFiles

    const toggleFavorite = useCallback(
        (ids, flag = true) => {
            const payload = pick(
                files.find(f => f.fileId === ids[0]),
                ['fileId', 'fileType', 'thumbnailId', 'patientId']
            )

            const isSelected = flag ? !favoriteFileIds.includes(payload.fileId) : flag
            const updatedSummary = getSummaryFromFiles(ids[0], files, summary, isSelected)
            dispatch(
                markFavorite({ favourites: [payload], fav: isSelected, summary: updatedSummary })
            )
        },
        [files, summary, favoriteFileIds]
    )

    const toggleAllFavorite = useCallback(
        (flag = true) => {
            let fileIds = flag ? arrayDifference(selectedFiles, favoriteFileIds) : selectedFiles
            let isSelected = flag
            if (flag && !fileIds.length) {
                fileIds = selectedFiles
                if (favoriteFileIds.includes(selectedFiles[0])) {
                    isSelected = false
                }
            }
            const payload = files
                .filter(f => fileIds.includes(f.fileId))
                .map(f => pick(f, ['fileId', 'fileType', 'thumbnailId', 'patientId']))

            const updatedSummary = getSummaryFromFiles(fileIds, files, summary, isSelected)
            dispatch(
                markFavorite({ favourites: payload, fav: isSelected, summary: updatedSummary })
            )
        },
        [files, selectedFiles, summary, favoriteFileIds]
    )

    const isAllFavorite = useMemo(
        () => !Boolean(arrayDifference(selectedFiles, favoriteFileIds).length),
        [selectedFiles, favoriteFileIds]
    )

    return {
        isAllFavorite,
        favoriteFiles,
        favoriteFileIds,
        latestDateTime,
        summary,
        toggleFavorite,
        toggleAllFavorite,
    }
}
